import { useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export interface CopyQuotePostRequestBody {
  sourceQuoteId: string;
  effectiveOn?: Date;
  writingCompanyId?: string;
  offeringId?: string;
  productOptionId?: string;
  productLabelId?: string;
  includeArtifacts?: boolean;
  enableV2Forms?: boolean;
  migrateV1Forms?: boolean;
}

export const useCopyQuote = () => {
  const client = useClient();

  const mutationFn = async (quoteData: CopyQuotePostRequestBody) => {
    return client.post(`quote-copy`, {
      json: {
        ...quoteData,
      },
    });
  };

  const result = useMutation({
    mutationFn,
  });
  return { ...result, copyQuoteAsync: result.mutateAsync };
};
